import React from 'react';

import './LevelingRankPicker.sass';

import {injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class LevelingRankPicker extends React.PureComponent {
  render() {
    const {intl, collapsed, min, max, marks, value, onChange} = this.props;

    return (
      <div>
        <div className="range-inputs">
          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.level'})}
              min={min}
              max={max}
              value={value[0]}
              onChange={(newValue) => onChange([newValue, value[1]])}
            />
          </div>

          <div className="range-inputs__divider" />

          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.wanted'})}
              min={min}
              max={max}
              value={value[1]}
              onChange={(newValue) => onChange([value[0], newValue])}
            />
          </div>
        </div>

        {!collapsed && (
          <div className="slider">
            <VariableStepRange
              className="rc-slider-flexible"
              step={1}
              min={min}
              max={max}
              marks={marks}
              value={value}
              onChange={onChange}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/levelingRankPicker/LevelingRankPicker.js